import React from 'react';

const GetPost = () => {
	return (
		<div>
			<h2 id="tasks_post">Get a Post</h2>
			<p>The next task we are going to demonstrate is how to get a post. Call the <em>/v1/post</em> API with the post GUID. As above, you can request images as an include option.</p>

			<h4>Request:</h4>
			<pre className="language-bash"><code className="language-bash">curl "http://sample.api.voicestorm.com/v1/post/b5d9993c59474c67ab9244b7a3afe0de?include=images"</code></pre>

			<h4>Response:</h4>
			<pre className="language-javascript"><code className="language-javascript">{`{
	postId: "b5d9993c59474c67ab9244b7a3afe0de",
	postSourceId: 1000,
	title: "http://www.wired.com/autopia/2013/08/hyperloop-elon-musk/",
	description: "This Is Hyperloop: Elon Musk's Vision of Mass Transit | Autopia | Wired.comElon Musk has unveiled his plans for the Hyperloop, an 800-mph tube that would shotgun passengers from SF to LA in 35 minutes at 700 mph.",
	content: "This Is Hyperloop: Elon Musk's Vision of Mass Transit | Autopia | Wired.comElon Musk has unveiled his plans for the Hyperloop, an 800-mph tube that would shotgun passengers from SF to LA in 35 minutes at 700 mph.",
	permaLink: "http://www.wired.com/autopia/2013/08/hyperloop-elon-musk/",
	cleanPermaLink: "http://www.wired.com/autopia/2013/08/hyperloop-elon-musk/",
	postType: "Text",
	postSourceType: "Brand",
	postBylineType: "Source",
	provider: "Facebook",
	approvalState: "Published",
	displayMode: "DisplayInAppWithLink",
	status: "Active",
	userEditable: false,
	sharable: true,
	broadcasted: false,
	pinned: false,
	publishDate: "2013-08-12T16:54:19.0000000Z",
	modifiedDate: "2013-08-28T00:31:04.4158190Z",
	createdDate: "2013-08-13T00:22:11.7609680Z",
	startDate: "2013-08-12T04:00:00.0000000Z",
	endDate: "2100-12-31T00:00:00.0000000Z",
	receivedPublishPoints: false,
	sharePoints: 5,
	clickPoints: 0,
	providerPostId: "100000000000000_000000000000000",
	urlSlug: "http-www-wired-com-autopia-2013-08-hyperloop-elon-musk",
	statistics: {
		totalInAppShareCount: 2,
		trackingId: "000000",
		shareCount: 2,
		reactionCount: 0,
		impressionCount: 0,
		clickCount: 1
	},
	author: {
		userId: 1000,
		author: "Sample User",
		profileImageUrl: "https://graph.facebook.com/v2.8/100000000000000/picture",
		providerUserName: "Sample User",
		profileUrl: "http://www.facebook.com/sample.user"
	},
	links: [],
	tags: [{
		name: "BrandSource",
		urlSafeName: "BrandSource"
	}],
	media: [],
	images: {
		Original: {
			size: "Original",
			cdnUrl: "https://cdn.rackcdn.com/101/post/f025fe96-afda-45e0-a242-a12f2906b15d",
			width: 154,
			height: 154,
			mimeType: "image/jpeg"
		},
		Box960: {
			size: "Box960",
			cdnUrl: "https://cdn.rackcdn.com/101/post/f025fe96-afda-45e0-a242-a12f2906b15d_B960",
			width: 154,
			height: 154,
			mimeType: "image/jpeg"
		},
		Square80: {
			size: "Square80",
			cdnUrl: "https://cdn.rackcdn.com/101/post/f025fe96-afda-45e0-a242-a12f2906b15d_S80",
			width: 80,
			height: 80,
			mimeType: "image/jpeg"
		},
		Box40: {
			size: "Box40",
			cdnUrl: "https://cdn.rackcdn.com/101/post/f025fe96-afda-45e0-a242-a12f2906b15d_B40",
			width: 40,
			height: 40,
			mimeType: "image/jpeg"
		}
	}
}
		`}
			</code></pre>
		</div>
	);
};

export default GetPost;


// WEBPACK FOOTER //
// ./src/components/getting-started/simpleTasks/GetPost.js